import axios from "lib/axios";

export const updateStructureApi = async (building_id, id, data) => {
  return await axios.patch(`/api/buildings/${building_id}/building_structures/${id}`, data);
};
